import { Button, type ButtonProps, Image } from "@mantine/core";

interface ContinueWithROIDProps extends ButtonProps {
  label?: string;
  variant?: "light" | "dark";
}

export function ContinueWithROID({
  label = "Continue with ROID",
  variant = "dark",
  ...props
}: ContinueWithROIDProps) {
  const isLight = variant === "light";

  return (
    <Button
      {...props}
      type="submit"
      radius="xl"
      size="lg"
      leftSection={<Image src="/assets/images/RO.svg" alt="RO Logo" w={24} />}
      variant={isLight ? "default" : "filled"}
      style={{
        height: 50,
        paddingLeft: 20,
        paddingRight: 30,
        backgroundColor: isLight ? "#19499A" : "#19499A",
        border: isLight ? "1px solid #19499A" : "none",
        color: isLight ? "white" : "white",
        fontFamily: "Gotham Rounded, sans-serif",
        fontWeight: 800,
        ...props.style,
      }}
    >
      {label}
    </Button>
  );
}
